import React, { useState, useEffect } from "react";
import client from "api/apiAuth/guestClient";
import _ from "lodash";
import {
  fetchWorklist,
  fetchWorklistLayout,
  fetchFilterData,
} from "reducers/list";
import { connect } from "react-redux";
import "./style.css";
import TableWithTabsAndFilters from "components/TableWithTabsAndFilters";
const menuObj =
  require(`../../weflow_configs/${process.env.REACT_APP_PROJECT_NAME}/tableTabs`).default;

const getDefaultTab = () => {
  return 0;
};
function WorkList(props) {
  let {
    getWorklist,
    tasks,
    tasksTotalCount,
    getLayout,
    columns,
    user,
    getFilterData,
    filterData,
  } = props;
  const form_id = props.match.params.form_id;
  const currentWorklist = form_id === "3" ? "CPMP" : "worklist";
  const currentFilter = form_id === "3" ? "CPMP" : "worklist";
  const [layoutStructure, setLayoutStructure] = useState([]);
  const [layoutData, setLayoutData] = useState();
  const [menus, setMenus] = useState(menuObj[currentWorklist].shared);
  const [filterColumns, setFilterColumns] = useState([]);
  const [currentTab, setCurrentTab] = useState(getDefaultTab(user));
  const [keyTab, setKeyTab] = useState("");

  useEffect(() => {
    getLayout({ table: currentWorklist }).catch((err) => {});
    getFilterData({ table: currentFilter }).catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    let isMounted = true;
    const fetchCounts = async () => {
      let extraTabs = [];
      user.roles.forEach((role) => {
        menuObj[currentWorklist][role.name].forEach((obj) => {
          if (!extraTabs.some((tab) => tab.id === obj.id)) {
            extraTabs.push(obj);
          }
        });
      });

      const newMenus = [...menus, ...extraTabs];
      for (const menu of newMenus) {
        if (isMounted) {
          try {
            const res = await client.get("tasks/find", {
              params: {
                currentTab: menu.id,
                form_id,
              },
            });
            menu.badge = res.data.count;
          } catch (error) {
            console.log(error);
            menu.badge = 0;
          }
        }
      }
      if (!_.isEmpty(user)) {
        setMenus(newMenus.sort((a, b) => a.order && a.order - b.order));

        setCurrentTab(newMenus[0].id);
        setKeyTab(newMenus[0].key);
      }
    };
    fetchCounts().catch((err) => {});
    return () => {
      isMounted = false;
    };
  }, [user]);

  useEffect(() => {
    setLayoutStructure(columns);
    setLayoutData(tasks);
    setFilterColumns(filterData);
  }, [tasks, columns, filterData]);
  return (
    <TableWithTabsAndFilters
      menus={menus}
      totalCount={tasksTotalCount}
      layoutStructure={layoutStructure}
      setLayoutStructure={setLayoutStructure}
      layoutData={layoutData}
      setLayoutData={setLayoutData}
      filterColumns={filterColumns}
      getTableData={(params) => getWorklist({ ...params, form_id })}
      currentTab={currentTab}
      setCurrentTab={setCurrentTab}
      redirectKey={keyTab}
      formId={form_id}
      setKeyTab={setKeyTab}
    />
  );
}
const mapStateToProps = (state) => {
  return {
    tasks: state.list?.tasks,
    tasksTotalCount: state.list?.tasksCount,
    user: state.auth.user,
    currentUser: state.auth.user,
    columns: state.layout.columns,
    filterData: state.filterData.filterData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getWorklist: (params) => dispatch(fetchWorklist(params)),
    getLayout: (params) => dispatch(fetchWorklistLayout(params)),
    getFilterData: (params) => dispatch(fetchFilterData(params)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WorkList);
